import { AppContent } from 'content/AppContent';

import * as routes from '../../routes/manifest';
import { MetaContentValues } from '../MetaContentValues';

const limitedCompanyLaunch: AppContent['limitedCompanyLaunch'] = {
  metaContent: MetaContentValues.LimitedCompanyLaunch,
  backLabel: 'Back',
  heading: 'Limited Company mortgages',
  atBmSolutions:
    'At BM Solutions, we also bring our buy to let (BTL) expertise to the limited company mortgage market. This is so we can support landlords who have set up limited companies and special purpose vehicles (SPVs) specifically for buying, selling and letting property.',
  weDeveloped:
    "We developed our proposition with intermediaries. It's designed to deliver fast, efficient lending decisions, removing the stress from this type of application.",
  keyCriteria: {
    heading: 'Key criteria',
    listItems: [
      ': SPVs with the following SIC codes - 68209, 68100, 68320, 68201.',
      ': Must be registered with Companies House before the application.',
      ': The company, property and all applicants (guarantors) must be located in England, Wales or Scotland.',
      ': Partnerships, limited liability partnerships (LLPs), trading or layered companies are not accepted.',
      ': Maximum of 4 parties who must collectively own 100% of the company.',
      ': All directors and shareholders must act as guarantors.',
      ': Required from all directors/shareholders for the full loan amount.',
      ': Mandatory for each personal guarantee.',
      ': Standard applicant requirements (for example age, income, tenancy type) will apply.',
    ],
    boldListItems: [
      'Eligible company types',
      'Company formation',
      'Location',
      'Ineligible entities',
      'Ownership structure',
      'Guarantor requirements',
      'Personal guarantees',
      'Independent legal advice',
      'Other criteria',
    ],
  },
  process: {
    heading: 'Process',
    listItems: [
      'All applications are submitted through this website.',
      'The type of limited company application is selected at the start.',
      'All company details are populated from Companies House by entering the company name or company number.',
      'All applicant details are prefilled from Companies House. Any missing information will need to be updated in the application.',
      'Any incorrect information will need to be updated with Companies House first.',
      'A standard application process then follows.',
    ],
  },
  helpfulInformation: {
    heading: 'More resources',
    navigationTiles: [
      {
        linkText: 'Full criteria guide',
        boxText:
          'A complete list of all the our criteria for limited company applications.',
        url: routes.LimitedCompanyCriteria,
      },
      {
        linkText: 'How to Place Business',
        boxText:
          'Submit a new limited company buy to let or let to buy application.',
        url: routes.SubmittingLimitedCompanyMortgageApplication,
      },
    ],
  },
  period: '.',
};

export default limitedCompanyLaunch;
